import { connect } from 'react-redux';
import { loginAction } from '@smorder/logic';
import Login from './login';

const mapStateToProps = state => ({
  loggedIn: state.authentication.loggedIn,
  userName: state.authentication.userName,
  isLoading: state.authentication.loading,
  errorMessage: state.authentication.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  login: (credentials) => {
    dispatch(loginAction.INIT(credentials));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
